import React from "react";
import { withTranslation } from "react-i18next";

import TextInput from "@krea/common/shared-components/fields/input";

const SsnInput = (props) => {
  const { value, touched, errors, label, t, onChange, onKeyDown, disabled } =
    props;

  return (
    <TextInput
      size="lg"
      id="ssn"
      type="text"
      name="ssn"
      label={label || t("applicationForm.commons.ssnLabel")}
      placeholder={t("applicationForm.commons.ssnPlaceholder")}
      autoComplete="off"
      value={value || ""}
      error={touched && errors ? errors : null}
      onChange={onChange}
      onKeyDown={onKeyDown}
      disabled={disabled}
    />
  );
};

export default withTranslation()(SsnInput);
